import React from 'react';
import { useTranslation } from 'react-i18next';
import Tooltip from '@mui/material/Tooltip';
import { InfoIcon } from './InfoIcon';
import { notices } from './data';

export interface NoticeMessageProps {
  slug: string;
  rowKey: string;
}

export const NoticeMessage = ({ slug, rowKey }: NoticeMessageProps) => {
  const { t, i18n } = useTranslation();

  const notice = notices[slug]?.find((notice) => notice.key === rowKey);

  if (!notice) return null;
  if (!i18n.exists(`banksComparisonTable.${slug}.${rowKey}Notice`)) return null;

  return (
    <Tooltip
      title={t(`banksComparisonTable.${slug}.${rowKey}Notice`) as string}
      leaveTouchDelay={3000}
      enterTouchDelay={50}
      placement="top"
      PopperProps={{
        modifiers: [
          {
            name: 'offset',
            options: {
              offset: [0, -10],
            },
          },
        ],
      }}
    >
      <InfoIcon variant={notice.noticeType} />
    </Tooltip>
  );
};
